window.addEventListener("load", function () {
  var musicUrl = $("#MS__wrapper").data("audio") || $("body").data("audio");
  if (!musicUrl) return;

  var audioElement = $('<audio id="backgroundMusic" loop></audio>');
  audioElement.append('<source src="' + musicUrl + '" type="audio/mpeg">');
  $("body").append(audioElement);

  var audio = document.getElementById("backgroundMusic");
  var hasInteracted = false;
  var $btnMusic = $(".btn-music");

  var syncBtnState = function () {
    if (audio.paused) {
      $btnMusic.removeClass("MS__sprite-musicon").addClass("MS__sprite-musicoff");
    } else {
      $btnMusic.removeClass("MS__sprite-musicoff").addClass("MS__sprite-musicon");
    }
  };
  audio.addEventListener("play", syncBtnState);
  audio.addEventListener("pause", syncBtnState);
  syncBtnState();

  var isPC = function () {
    return window.matchMedia("(min-width: 769px)").matches;
  };

  $btnMusic.on("click", function (e) {
    e.preventDefault();
    if (!isPC()) return;
    hasInteracted = true;
    if (audio.paused) {
      audio.play().catch(function (error) {
        console.log("Audio play error:", error);
      });
    } else {
      audio.pause();
    }
  });

  var autoPlayHandler = function () {
    if (hasInteracted) return;
    hasInteracted = true;
    audio.play().catch(function (error) {
      console.log("Autoplay prevented:", error);
    });
    $(document).off("click touchstart", autoPlayHandler);
  };
  $(document).on("click touchstart", autoPlayHandler);

  document.addEventListener("visibilitychange", function () {
    if (document.hidden) {
      if (!audio.paused) audio.pause();
    } else if (hasInteracted && audio.paused) {
      audio.play().catch(function (error) {
        console.log("Audio resume error:", error);
      });
    }
  });
});
